import { Box, Input, InputBase, SvgIcon, Typography } from "@mui/material";
import AddressAutoComplete from "components/general/AddressAutoComplete";

const LocationFilter = ({ onChange, value }: { onChange: any; value: any }) => {
  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        px: "20px",
        py: "10px",

        // width: {
        //   md: "250px",
        //   lg: "280px",
        //   xl: "280px",
        //   sm: "300px",
        //   xs: "300px",
        // },
        flex: 1,
      }}
    >
      <Typography
        sx={{
          color: "#383838",
          fontWeight: 600,
          fontSize: "13px",
          lineHeight: "22px",
          fontFamily: "Inter",
        }}
      >
        Location
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <AddressAutoComplete
          onSelect={(location: any) => onChange(location)}
          defaultValue={{
            description: "",
            structured_formatting: {
              main_text: value?.description ?? "",
              secondary_text: "",
            },
          }}
          minWidth={100}
          CustomInput={(params: any) => (
            <InputBase
              ref={params.InputProps.ref}
              inputProps={{
                ...params.inputProps,
              }}
              sx={{
                input: {
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "15px",
                  lineHeight: "22px",
                  // width: {
                  //   md: "200px",
                  //   lg: "200px",
                  //   xl: "300px",
                  //   sm: "300px",
                  //   xs: "300px",
                  // },
                  padding: "0px",
                },
              }}
              placeholder="Search location..."
            />
          )}
        />
        <img
          src="/assets/img/icons/location_search.svg"
          height="24"
          width="24"
          alt="Location Search"
        />
      </Box>
    </Box>
  );
};

export default LocationFilter;
